var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-devices-desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_152",
    "data-name": "Vrstva 152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.72,
    y: 2.94,
    width: 20.55,
    height: 14.32,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.13,
    y1: 17.25,
    x2: 9.13,
    y2: 21.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.87,
    y1: 17.25,
    x2: 14.87,
    y2: 21.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.32,
    y1: 21.06,
    x2: 18.68,
    y2: 21.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktop-icon.f96c6ad6863199595cf70c427f3c0613.svg";
export { ForwardRef as ReactComponent };